<template>
    <div class="dialog-body">
       <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="dialog-form">
			<el-form-item label="单位名称：" prop="unitName" :inline-message='true'>
				<el-input
					v-model="ruleForm.unitName"
					@blur="unitNameChange"
					placeholder="请输入单位名称"
					size="small"
					:maxlength="10"
					inline-message='true'
					class="dialog-input"
				/>
			</el-form-item>
			<el-form-item label="单位规格：" prop="spec" :inline-message='true'>
				<el-input
					v-model="ruleForm.spec"
					placeholder="请输入单位规格"
					size="small"
					:maxlength="10"
					class="dialog-input"
				/>
			</el-form-item>
			<el-form-item label="标准重量：" prop="standardWeight" :inline-message='true'>
				<el-input
					v-model="ruleForm.standardWeight"
					placeholder="请输入标准重量"
					size="small"
					type="number"
					@blur="standardWeightBlur"
					class="dialog-input"
				/>
			</el-form-item>
			<el-form-item label="商品价格：" prop="defaultPrice" :inline-message='true'>
				<el-input
					v-model="ruleForm.defaultPrice"
					placeholder="请输入商品价格"
					size="small"
					type="number"
					@blur="priceBlur"
					class="dialog-input"
				/> 元
			</el-form-item>
		</el-form>
		<div class="btn-box">
			<el-button class="btn" plain type="primary" @click="cancel">取消</el-button>
			<el-button class="btn" type="primary" v-show="true" @click="confirm">确认</el-button>
		</div>
    </div>
</template>

<script>
export default {
	name: 'unitDialog',
	props: {
		visible: {
			type: Boolean
		},
		itemData: {
			type: Object
		}
	},
	data () {
		var defaultPriceLimit = (rule, value, callback) => {
			if (value < 0) {
				callback(new Error('不能小于0'))
			} else {
				callback()
			}
			if (value < 100000000) {
				callback()
			} else {
				callback(new Error('字符最大长度10'))
			}
		}
		var standardWeightLimit = (rule, value, callback) => {
			if (value < 0) {
				callback(new Error('不能小于0'))
			} else {
				callback()
			}
			if (value < 10000000) {
				callback()
			} else {
				callback(new Error('字符最大长度10'))
			}
		}
		return {
			ruleForm: {
				unitName: '',
				spec: '',
				standardWeight: '',
				defaultPrice: '0.00'
			},
			rules: {
				unitName: [
					{ required: true, message: '请输入商品名称', trigger: 'blur' }
				],
				standardWeight: [
					{ required: true, message: '请输入标准重量', trigger: 'blur' },
					{ validator: standardWeightLimit, trigger: 'blur' }
				],
				defaultPrice: [
					{ required: true, message: '请输入统一单价', trigger: 'blur' },
					{ validator: defaultPriceLimit, trigger: 'blur' }
				]
			}
		}
	},
	created () {
		this.ruleForm.unitName = this.itemData.name
		this.ruleForm.spec = this.itemData.spec
		this.ruleForm.defaultPrice = this.$fxUtils.toFixedSHW(this.itemData.defaultprice, 2)
		this.ruleForm.standardWeight = this.$fxUtils.toFixedSHW(this.itemData.standardweight, 3)
	},
	methods: {
		unitNameChange () {
			this.ruleForm.unitName = this.ruleForm.unitName.trim()
		},
		confirm () {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					this.confirmPost()
				}
			})
		},
		priceBlur () {
			if (this.ruleForm.defaultPrice) {
				this.ruleForm.defaultPrice = this.$fxUtils.toFixedSHW(this.ruleForm.defaultPrice, 2)
			}
		},
		standardWeightBlur () {
			if (this.ruleForm.standardWeight) {
				this.ruleForm.standardWeight = this.$fxUtils.toFixedSHW(this.ruleForm.standardWeight, 3)
			}
		},
		cancel () {
			this.$emit('update:visible', false)
		},
		confirmPost () {
			let params = {
				id: this.itemData.id ? this.itemData.id : '0',
				goodsId: sessionStorage.getItem('goodsid'),
				unitName: this.ruleForm.unitName,
				spec: this.ruleForm.spec,
				defaultPrice: '' + this.ruleForm.defaultPrice,
				standardWeight: +this.ruleForm.standardWeight
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/saveOrUpdateGoodsUnit`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.$emit('confirmHandle')
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.dialog-body {
	.dialog-form {
		display flex
		flex-direction column
		.el-form-item {
			display flex
			flex-direction row
			/deep/.el-form-item__label {
				width: 120px
			}
			/deep/.el-input__inner {
				line-height: 10px;
			}
			.dialog-input {
				width: 220px
				line-height: 10px!important
			}
		}
	}
	.btn-box {
		text-align center
		padding-top: 50px
		.btn {
			width: 150px
		}
	}
}
</style>
